import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33843280"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "layout__wrapper-inner container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " It looks like you’re offline. Please connect to the Internet and try again. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Alternatively, you can send us an email directly at "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:help@shortform.com" }, "help@shortform.com"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_4 = {
  key: 1,
  class: "layout__wrapper-inner container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help__subtitle" }, [
  /*#__PURE__*/_createTextVNode(" Fill out the form below, or send us an email directly at "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:help@shortform.com" }, "help@shortform.com")
], -1))
const _hoisted_6 = { class: "alert alert-success" }
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = {
  id: "support-edit-form-group-subject",
  class: "form__group"
}
const _hoisted_9 = {
  tabindex: "-1",
  role: "group"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form__label form__label--large" }, " To get more help, write a descriptive subject ", -1))
const _hoisted_11 = {
  id: "support-edit-form-group-body",
  class: "form__group"
}
const _hoisted_12 = {
  tabindex: "-1",
  role: "group"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form__label form__label--large" }, "Request", -1))
const _hoisted_14 = {
  key: 0,
  class: "invalid-feedback error-body"
}
const _hoisted_15 = {
  type: "submit",
  class: "btns"
}
const _hoisted_16 = {
  class: "help__version",
  href: "javascript:window.location.reload()"
}

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useWait } from '@/app/composables/useWait'

import RootPageLayout from '@/app/components/RootPageLayout.vue'
import ContentWrapper from '@/components/ui/ContentWrapper.vue'
import FormError from '@/components/ui/FormError.vue'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'

import { APP_VERSION } from '@/init/settings'
import { ValidationState, setInputFocusStart } from '@/helpers/form'
import { offline } from '@/services/offline'
import { backend } from '@/services/backend'
import { platform } from '@/services/platform'
import { processDevCommands } from '@/services/commands'


export default /*#__PURE__*/_defineComponent({
  __name: 'Help',
  setup(__props) {

const router = useRouter()
const wait = useWait()

const subjectInput = ref<InstanceType<typeof InputWithContextMenu> | null>(null)

const validation = ref(new ValidationState())
const redirectDelay = ref(2000)

const sentAlert = ref(false)
const subject = ref('')
const body = ref('')

onMounted(async () => {
  if (offline.isOnline) {
    const input = subjectInput.value?.$el
    setInputFocusStart(input)

    const info = await platform.deviceInfo()
    if (window.__UNIT_TESTING !== true) {
      console.log(info)
    }
  }
  processDevCommands()
})

async function send(): Promise<void> {
  try {
    wait.start('Sending')
    await backend.sendSupportRequest(subject.value, body.value)
    validation.value.reset()

    // Show subscribed alert and redirect to books page after delay.
    sentAlert.value = true

    setTimeout(() => {
      wait.end('Sending')
      router.push({ name: 'home' })
    }, redirectDelay.value)
  } catch (error) {
    validation.value.showErrors(error)
    wait.end('Sending')
  }
}

function isOffline(): boolean {
  return offline.isOffline
}

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!
  const _directive_wait = _resolveDirective("wait")!

  return (_openBlock(), _createBlock(RootPageLayout, {
    class: "help",
    title: "Support Request",
    mobileTitle: "Support"
  }, {
    default: _withCtx(() => [
      (isOffline())
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(ContentWrapper, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _hoisted_3
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(ContentWrapper, null, {
              default: _withCtx(() => [
                _hoisted_5,
                _withDirectives(_createElementVNode("div", _hoisted_6, " Successfully sent a request. ", 512), [
                  [_vShow, sentAlert.value]
                ]),
                _createElementVNode("form", {
                  role: "form",
                  class: "form",
                  novalidate: "",
                  onSubmit: _withModifiers(send, ["prevent"])
                }, [
                  _createElementVNode("fieldset", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(InputWithContextMenu, {
                        id: "support-edit-subject",
                        ref_key: "subjectInput",
                        ref: subjectInput,
                        modelValue: subject.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((subject).value = $event)),
                        placeholder: "Enter subject here",
                        type: "text",
                        class: _normalizeClass([validation.value.stateClass('subject'), "form-control"])
                      }, null, 8, ["modelValue", "class"]),
                      _createVNode(FormError, {
                        errors: validation.value.errors,
                        field: "subject"
                      }, null, 8, ["errors"])
                    ])
                  ]),
                  _createElementVNode("fieldset", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(InputWithContextMenu, {
                        id: "support-edit-body",
                        ref: "bodyTextarea",
                        modelValue: body.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((body).value = $event)),
                        elementType: "textarea",
                        placeholder: "How can we help?",
                        rows: "8",
                        type: "text",
                        class: _normalizeClass([validation.value.stateClass('body'), "form-control"])
                      }, null, 8, ["modelValue", "class"]),
                      _createVNode(FormError, {
                        errors: validation.value.errors,
                        field: "body"
                      }, null, 8, ["errors"])
                    ])
                  ]),
                  (validation.value.errors && validation.value.errors._schema)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, " {validation.errors._schema} "))
                    : _createCommentVNode("", true),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_15, [
                    _createVNode(_component_v_wait, { for: "Sending" }, {
                      waiting: _withCtx(() => [
                        _createTextVNode(" Sending "),
                        _createVNode(ButtonSpinner)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" Send request ")
                      ]),
                      _: 1
                    })
                  ])), [
                    [_directive_wait, 'Sending', "disabled"]
                  ]),
                  _createElementVNode("a", _hoisted_16, "v " + _toDisplayString(_unref(APP_VERSION)), 1)
                ], 40, _hoisted_7)
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }))
}
}

})